<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <v-text-field v-model="fields['card-title']" label="Card Title" />
          <v-textarea outlined v-model="fields['card-description']" label="Card Description" />
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields['text-color']" label="Text Color" />
                  <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="head"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['background-color']"
                      @change="handleChangeBackgroundColor"
                    />
                    <v-text-field v-model="fields['background-color']" label="Background Color" />
                    <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-checkbox v-model="fields['card-btn-row']" label="Show Button" />
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="fields['card-btn'].text" label="Button Text" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="fields['card-btn'].url" label="Button URL" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-bg"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-btn']['background']"
                    @change="handleChangeButtonBackground"
                  />
                  <v-text-field v-model="fields['card-btn']['background']" label="Button Background Color" />
                  <v-btn @click="handleResetButtonBackground" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-text"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-btn']['color']"
                    @change="handleChangeButtonTextColor"
                  />
                  <v-text-field v-model="fields['card-btn']['color']" label="Button Text Color" />
                  <v-btn @click="handleResetButtonTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-border"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-btn']['border']"
                    @change="handleChangeButtonBorderColor"
                  />
                  <v-text-field v-model="fields['card-btn']['border']" label="Button Border Color" />
                  <v-btn @click="handleResetButtonBorderColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'find-answer-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'card-title': '',
        'card-description': '',
        'card-btn-row': false,
        'card-btn': {
          text: '',
          url: '',
          background: '',
          color: '#FFFFFF',
          border: '#2d3436',
        },
        'text-color': '',
        'background-color': '',
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFindAnswer(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
    handleChangeButtonBackground(event) {
      this.fields['card-btn']['background'] = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields['card-btn']['color'] = event.target.value;
    },
    handleResetButtonBackground() {
      this.fields['card-btn']['background'] = '';
    },
    handleResetButtonTextColor() {
      this.fields['card-btn']['color'] = '';
    },
    handleChangeButtonBorderColor(event) {
      this.fields['card-btn']['border'] = event.target.value;
    },
    handleResetButtonBorderColor() {
      this.fields['card-btn']['border'] = '#2d3436';
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
